<!-- API call across app -->
<div [hidden]="!shared?.isServiceHit" class="overlay-loader">
  <!-- <img *ngIf="utils?.businessUnit=='MF'" src="assets/images/Investica-Loader.gif">
  <img *ngIf="utils?.businessUnit=='JF'" src="assets/images/Jiffy-Loader.gif"> -->
  <!-- <img src="assets/images/Choice-Loader.gif"> -->
  <!--  {{shared?.loadingMessage||'Loading..'}} -->
  <div class="loader"></div>
  <div class="loader-text" *ngIf="shared?.loadingMessage">
    {{ shared?.loadingMessage || "Loading" }}
  </div>
</div>
<!-- Module load & Routing navigation -->
<div
  [hidden]="!config.isModuleStart || shared?.isServiceHit"
  class="overlay-loader"
>
  <!-- <img *ngIf="utils?.businessUnit=='MF'" src="assets/images/Investica-Loader.gif">
  <img *ngIf="utils?.businessUnit=='JF'" src="assets/images/Jiffy-Loader.gif"> -->
  <!-- <img src="assets/images/Choice-Loader.gif"> -->
  <div class="loader"></div>
  <div class="loader-text">
    {{ "Loading" | lang : "loading" : utils.langData }}
  </div>
</div>
<nav class="headerbg">
  <div class="container">
    <div class="row d-flex justify-content-center">
      <div
        class="col-lg-10 col-xl-8 d-flex justify-content-center align-items-center"
      >
        <!-- <span
          class="back-btn"
          (click)="backHandler()"
          appRipple
          *ngIf="config.isBack"
        >
          <i class="icon-back"></i>
        </span> -->
        <img
          class="logo"
          src="../assets/images/logo.png"
          alt="Best Stock Broking in India"
        />
        <!-- <img class="logo" *ngIf="utils?.businessUnit=='MF'" src="../assets/images/investica-Logo.gif" alt="Investica - Mutual Fund Investment Platform"> -->
        <div class="rt-sec d-flex align-items-center ml-auto">
          <!-- [disabled]="langQueryParam"  -->
          <div class="select-dropdown" [class.hidee]="config?.hideLang">
            <select id="langSelect" (change)="langChange($event)">
              <option value="en">English</option>
              <option value="hi">हिंदी</option>
            </select>
          </div>
          <a
            *ngIf="config.isSkip"
            (click)="openSkipModal()"
            class="float-right skip-btn"
            appRipple
          >
            {{ "Skip" | lang : "skipLabel" : utils.langData }}
          </a>
          <a
            *ngIf="config.isSupport"
            [routerLink]="
              utils?.businessUnit == 'MF' ? '/mf/support' : '/trading/support'
            "
            class="float-right call-support"
            appRipple
          >
            <i class="icon-headphone"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</nav>
<!-- Modal across app -->
<div *ngIf="utils.modalConfig" class="dialog">
  <div class="dialog-main">
    <div class="dialog-header" *ngIf="utils.modalConfig?.title">
      {{
        utils?.modalConfig?.title
          | lang : utils?.modalConfig?.titleKey : utils.langData
      }}
    </div>
    <div
      class="dialog-body"
      [innerHTML]="
        (utils.modalConfig?.message
          | lang : utils?.modalConfig?.messageKey : utils.langData) | safeUrl
      "
    >
      <!-- This PAN is already associated with another account. Please Login or contact support team -->
    </div>
    <div class="dialog-footer">
      <div class="row d-flex justify-content-center">
        <div
          [class.col-12]="utils?.modalConfig?.actions?.length == 1"
          [class.col-4]="utils?.modalConfig?.actions?.length > 1"
          [class.text-center]="utils?.modalConfig?.actions?.length == 1"
          *ngFor="let button of utils.modalConfig.actions; let i = index"
        >
          <button
            type="button"
            class="btn col-md-12 {{ button?.class || 'btn-gradient' }}"
            [class.ml-1]="i > 0"
            [class.m-l-sm-1]="i > 1"
            appRipple
            (click)="button?.handler()"
          >
            <span>{{
              button?.label | lang : button.key : utils.langData
            }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<main
  class="container screen-d"
  *ngIf="
    utils?.businessUnit &&
    screenData &&
    (eventURL?.indexOf('document-uploads') > -1 ||
      eventURL?.indexOf('nominee-details') > -1)
  "
>
  <div class="row d-flex justify-content-center">
    <div class="col-sm-8 col-12 d-flex justify-content-center">
      <div class="progress-sec">
        <ul>
          <ng-container *ngFor="let screen of screenData; let i = index">
            <ng-container *ngIf="screen?.ispresent">
              <li
                class="success"
                *ngIf="
                  screen?.isCompleted && !(eventURL?.indexOf(screen?.key) > -1)
                "
              >
                <a>
                  <span>{{ screen?.name }}</span>
                </a>
              </li>
              <li class="active" *ngIf="eventURL?.indexOf(screen?.key) > -1">
                <a>
                  <span>{{ screen?.name }}</span>
                </a>
              </li>
              <li
                class="pending"
                *ngIf="
                  !screen?.isCompleted && !(eventURL?.indexOf(screen?.key) > -1)
                "
              >
                <a>
                  <span>{{ screen?.name }}</span>
                </a>
              </li>
            </ng-container>
          </ng-container>

          <!-- <li class="">
                        <a href="#">
                            <span>Step 04</span>
                            <span>May 08, 2021</span>
                        </a>
                    </li> -->
        </ul>
      </div>
    </div>
  </div>
</main>
<div
  class="row"
  class="screen-d"
  *ngIf="
    false &&
    utils?.businessUnit &&
    screenData &&
    !(eventURL?.indexOf('reviewed') > -1)
  "
>
  <div class="col-md-12">
    <!--       <div class="progress-sec d-flex justify-content-center">
          <ul>
              <li class="success">
                  <a href="#">
                      <span>Step 01</span>
                      <span>May 07, 2021</span>
                  </a>
              </li>
              <li class="active">
                  <a href="#">
                      <span>Step 02</span>
                      <span>May 07, 2021</span>
                  </a>
              </li>
              <li class="pending">
                  <a href="#">
                      <span>Step 03</span>
                      <span>May 08, 2021</span>
                  </a>
              </li>
              <li class="">
                  <a href="#">
                      <span>Step 04</span>
                      <span>May 08, 2021</span>
                  </a>
              </li>
          </ul>
      </div> -->
    <!--     <div class="onboarding-progress" *ngIf="screenData">
      <ng-container *ngFor="let screen of screenData; let i = index;">
        <div *ngIf="screen?.ispresent" class="process" [ngClass]="{'completed': screen?.isCompleted, 'in-progress': ((eventURL?.indexOf(screen?.key)>-1))}">
          <div class="count" *ngIf="(screen?.isCompleted)&&!((eventURL?.indexOf(screen?.key)>-1))"><i class="icon-checkmark-outline"></i></div>
          <div class="count" *ngIf="((eventURL?.indexOf(screen?.key)>-1))">O</div>
          <div class="count" *ngIf="!screen?.isCompleted && !((eventURL?.indexOf(screen?.key)>-1))">o</div>
          <div class="details">
            {{screen?.name}}
          </div>
        </div>
      </ng-container>
    </div> -->
    <!--     <div class="container-fluid">
     
      <ul class="list-unstyled multi-steps" [ngClass]="{'display-con':utils?.isMobile}">
        <li *ngFor="let screen of screenData; let i = index;" [ngClass]="{'is-active':(((eventURL?.indexOf(screen?.key)>-1))) , 'texdt':(screenData?.length-1==i)}">  {{screen?.name}}</li>
      </ul>
    </div> -->

    <!--     <ul class="progress">
      <li class="progress__circle progress--done progress--active"></li>
      <li class="progress__bar progress--done"></li>
      <li class="progress__circle progress--active progress--done"></li>
      <li class="progress__bar progress--done"></li>
      <li class="progress__circle progress--active"></li>
      <li class="progress__bar"></li>
      <li class="progress__circle"></li>
      <li class="progress__bar"></li>
      <li class="progress__circle"></li>
    </ul> -->
  </div>
</div>
<router-outlet> </router-outlet>

<!-- OTP button acorss app to open the modal -->
<button
  class="btn btn-gradient fab"
  *ngIf="
    utils.otpFormModal &&
    utils.otpFormModal?.isHidden &&
    !utils?.otpFormModal?.isSkip
  "
  (click)="openOtpModal()"
>
  {{ "OTP" | lang : "otplbl" : utils.langData }}
</button>
<app-otp-verify
  *ngIf="utils.otpFormModal"
  [contactUpdationType]="utils.otpFormModal?.contactUpdationType"
  [formValues]="utils.otpFormModal?.formValues"
  [hidden]="utils.otpFormModal?.isHidden"
  (onActionClicked)="onActionClicked($event)"
>
</app-otp-verify>
